import { render, staticRenderFns } from "./GestionPage.vue?vue&type=template&id=1cdc0687&"
import script from "./GestionPage.js?vue&type=script&lang=js&"
export * from "./GestionPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports